'use strict';
/*exported Cookies */
function Cookies() {
  this.init();
}

Cookies.prototype = $.extend({}, {
  constructor: 'Cookies',

  //**************************************************************************

  // uložení cookie
  set: function set(name, value, expFromNow) {
    var _this = this;

    expFromNow = expFromNow || 30 * 24 * 60 * 60 * 1000;  // Expires in 30 Days
    var exp = new Date();
    exp.setTime(exp.getTime() + expFromNow);

    document.cookie = (name + '=' + encodeURIComponent(value) + ';expires=' + exp.toGMTString() + ';path=/');

    return _this;
  },

  setJSON: function setJSON(name, value) {
    var _this = this;

    _this.set(name, JSON.stringify(value));

    return _this;
  },

  // načtení cookie
  get: function get(name) {
    var search = name + '=';

    if (document.cookie.length > 0) {
      var offset = document.cookie.indexOf(search);
      if (offset !== -1) {
        offset += search.length;
        var end = document.cookie.indexOf(';', offset);
        end = (end === -1 ? document.cookie.length : end);

        return decodeURIComponent(document.cookie.substring(offset, end));
      }
    }

    return null;
  },

  getJSON: function getJSON(name) {
    var _this = this;

    var value = _this.get(name);
    if (value) {
      return JSON.parse(value);
    }

    return {};
  },

  //**************************************************************************
  init: function init() {
    var _this = this;

    return _this;
  }
});
